"use client";

import { LicenseProvider } from '@/contexts/LicenseContext';
import { InstacartAuthProvider } from '@/contexts/InstacartAuthContext';
import { UserLocationProvider } from '@/contexts/UserLocationContext';
import { AppProvider } from '@/contexts/AppContext';
import { StoreLocationsProvider } from '@/contexts/StoreLocationsContext';
import { ActiveBatchProvider } from '@/contexts/ActiveBatchContext';
import TabBarWrapper from '@/components/layout/TabBarWrapper';

export default function ProtectedLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <LicenseProvider>
      <InstacartAuthProvider>
        <UserLocationProvider>
          <AppProvider>
            <StoreLocationsProvider>
              <ActiveBatchProvider>
                {children}
                <TabBarWrapper />
              </ActiveBatchProvider>
            </StoreLocationsProvider>
          </AppProvider>
        </UserLocationProvider>
      </InstacartAuthProvider>
    </LicenseProvider>
  );
} 